import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
  Typography,
} from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import React, { useState } from 'react';
import {useForm} from 'react-hook-form';
import PropTypes from 'prop-types';
import { useSnackbar } from 'notistack';
import globalUseStyles from '../../../../../styles';

const CompartilharCard = (props) => {
  const {
    open, onClose, onCompartilharCard, id,
  } = props;
  const globalClasses = globalUseStyles();
  const [email, setEmail] = useState('');
  const { register, handleSubmit, errors } = useForm();
  const { enqueueSnackbar } = useSnackbar();

  const onSubmit = async () => {
    try {
      const response = await onCompartilharCard(id, email);

      if (response && response.status === 200) {
        enqueueSnackbar('Compartilhamento realizado com sucesso', { variant: 'success' })
      }else {
        enqueueSnackbar('Erro ao realizar compartilhamento', { variant: 'error' })
      }

    } catch (e) {
      enqueueSnackbar('Erro ao realizar compartilhamento', { variant: 'error' })
    }

    onClose(false);
  };

  return (
    <Dialog fullWidth open={open} onClose={onClose}>
      <DialogTitle>
        <IconButton className={globalClasses.closeButtonDialog} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <form onSubmit={handleSubmit(onSubmit)}>
        <DialogContent>
          <Typography paragraph className={globalClasses.tituloDialog}>Digite um email</Typography>
          <Grid container>
            <Grid item lg={12}>
              <TextField
                id="email"
                name="email"
                InputLabelProps={{ shrink: true }}
                variant="outlined"
                fullWidth
                onChange={(event) => setEmail(event.target.value)}
                valeu={email}
                error={!!errors.email}
                helperText={errors.email && errors.email.message}
                inputRef={register({
                  required: 'Informe um e-mail',
                })}
              />
            </Grid>
          </Grid>
          <DialogActions style={{ borderTop: 'none' }}>
            <Button
              variant="contained"
              type="submit"
            >
            Enviar
            </Button>
          </DialogActions>
        </DialogContent>
      </form>

    </Dialog>
  )
};

CompartilharCard.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onCompartilharCard: PropTypes.func.isRequired,
  id: PropTypes.number.isRequired,
};

export default CompartilharCard;
